import './App.css';
import { BrowserRouter as Router, Routes, Route, useNavigate } from "react-router-dom";
import { Toaster } from 'react-hot-toast';
import PublicRoutes from './routes/publicRoutes';
import PrivateRoutes from './routes/privateRoutes';
import Login from './pages/auth/login';
import Event from './pages/event/event';
import EventDashboard from './pages/event/eventDashboard';
import StandList from './pages/event/standList';
import RetroPlan from './pages/event/retroPlan';
import History from './pages/event/history';
import Security from './pages/event/security';
import Cleaning from './pages/event/cleaning';
import Settings from './pages/event/profile';
import StaffMark from './pages/staff/staffMark';
import PageNotFound from './components/pageNotFound';
import Badging from './pages/event/badging';
import Scan from './pages/staff/scan';
import Clean from './pages/staff/clean';
import Hse from './pages/staff/hse';
import StandisteForm from './pages/standiste/standisteForm';
import StandisteStaff from './components/standisteStaff';
import NoAccess from './components/noAccess';
import BadgeCustomization from './pages/event/badgeCustomization';
import { BulkSendProvider } from "./utils/Bulksendcontext";
import BulkSendWidget from "./utils/Bulksendwidget";
import ConstractorForm from './pages/standiste/constractorForm';
import RetroPlanPublic from './pages/event/retroPlanPublic';
import axiosInstance from './utils/api';
import { useEffect } from 'react';
import Dashboard from './pages/Dashboard';

function ImpersonationHandler() {
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("impersonate") !== "1") return;

    const code = params.get("code");
    if (!code) return;

    axiosInstance.post("/auth/exchange", { code })
      .then(({ data }) => {
        localStorage.setItem("token", data.accessToken);
        localStorage.setItem("refreshToken", data.refreshToken);
        if (data.user.event) {
          localStorage.setItem("event", data.user.event);
          navigate(`/event/${data.user.event}/dashboard`, { replace: true });
        } else {
          navigate("/dashboard", { replace: true });
        }
      })
      .catch((e) => console.error("Impersonation error", e));
  }, [navigate]);

  return null;
}

function App() {

  return (
    <>
      <BulkSendProvider>
        <Toaster position="top-right" />
        <Router>
          <ImpersonationHandler />
          <Routes>
            <Route path='/' element={<PublicRoutes element={Login} />} />
            <Route path='/no-access' element={<PublicRoutes element={NoAccess} />} />
            <Route path='/:eventId' element={<PublicRoutes element={StandisteForm} />} />
            <Route path='/:eventId/contractor' element={<PublicRoutes element={ConstractorForm} />} />
            <Route path='/staff' element={<PrivateRoutes element={StaffMark} />} />
            <Route path='/scan' element={<PrivateRoutes element={Scan} />} />
            <Route path='/hse' element={<PrivateRoutes element={Hse} />} />
            <Route path='/cleaning' element={<PrivateRoutes element={Clean} />} />
            <Route path='/dashboard' element={<PrivateRoutes element={Dashboard} />} />
            <Route path="/event/:id/*" element={<PrivateRoutes element={Event} />}>
              <Route path='dashboard' element={<EventDashboard />} />
              <Route path='stand-list' element={<StandList />} />
              <Route path='retro-plan' element={<RetroPlan />} />
              <Route path='security' element={<Security />} />
              <Route path='cleaning' element={<Cleaning />} />
              <Route path='badging' element={<Badging />} />
              <Route path='history' element={<History />} />
              <Route path='profile' element={<Settings />} />
              <Route path='badge-customization' element={<BadgeCustomization />} />
              <Route path=':standisteId' element={<StandisteStaff />} />
            </Route>
            <Route path='/:eventId/retro' element={<PublicRoutes element={RetroPlanPublic} />} />
            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </Router>
        <BulkSendWidget />
      </BulkSendProvider>
    </>
  );
}

export default App;
